module.exports = __webpack_public_path__ + "static/media/everyday_digital.b1a41765.png";